import { 
    MN_PIN,
    SOCKS,
    Product
} from '../products';

const classicYouthRecos: Product[] = [
    MN_PIN,
    SOCKS,
];

export default classicYouthRecos;
 